import { JsonObject, JsonProperty } from "json2typescript";
import { DateConverter } from "domain/entities/decorators/DateConverter";

@JsonObject("SeverityResult")
export class SeverityResult {
    @JsonProperty("dse_id", Number)
    id: number = 0;
    @JsonProperty("dse_name", String)
    name: string = "";
    @JsonProperty("dse_description", String)
    description: string = "";
    @JsonProperty("dse_created_at", DateConverter)
    createdAt: Date = new Date();
    @JsonProperty("dse_updated_at", DateConverter)
    updatedAt: Date = new Date();
}